import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {Staffs} from '../../models/staff/staffs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {FileItem} from '../../models/file/fileitem';
const apiUrl = `${environment.apiUrl}/avatar`;
const apiFileUrl = `${environment.apiUrl}/document`;

@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor(public httpService: HttpClient) {
  }

  public upload(file: File): Observable<FileItem>
  {
    const formData = new FormData();

    formData.append("fileItem", file);

    return this.httpService.post(`${apiUrl}/upload`, formData).pipe(
      map(data => new FileItem().deserialize(data)));

  }

}
